import { Box, Typography } from '@mui/material';
import React from 'react';

import availabilityImage from 'assets/images/help-pdp-availability.png';
import HelpImage from 'ui/help/HelpImage';

// TODO internationalize if we end up caring about it

const HelpAvailability = () => {
  return (
    <Box>
      <Typography variant='body1'>
        Since we may carry a specific item in many different locations, we have
        a way to track where an item is availabile. The availability section of
        the product details page handles this, and shows some useful information
        about an item such as if it is available or not, along with links to
        each item in each location to get more details information.
      </Typography>
      <HelpImage imageSrc={availabilityImage} alt='availibility section' />
    </Box>
  );
};

export default HelpAvailability;
